import { Typography } from '@mui/material'

const PageTitle = () => (
  <Typography variant="h4" align="center">
    Fast geschafft! Einen Augenblick noch.
  </Typography>
)

export { PageTitle }
